import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators, AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { AuthService } from '../../../../abstraction/auth.service';
import errors from '../../../../utils/errorCodes';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
})
export class ChangePasswordDialogComponent implements OnInit {
  formGroup: FormGroup;
  hideNewPassword = true;
  hideRepeatPassword = true;
  loading = false;
  showMessage = false;

  constructor(
    private authService: AuthService,
    private dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
  ) {}

  ngOnInit(): void {
    const passwordValidators = [
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
    ];

    this.formGroup = new FormGroup({
      newPasswordControl: new FormControl('', passwordValidators),
      repeatPasswordControl: new FormControl('', [
        ...passwordValidators,
        this.checkPasswordRepeatValidator(),
      ]),
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  changePassword(): void {
    if (this.formGroup.invalid) {
      return;
    }

    this.loading = true;
    this.authService
      .changeCommercePassword(this.formGroup.controls.newPasswordControl.value as string)
      .subscribe(
        () => {
          this.showMessage = true;
          setTimeout(() => {
            this.dialogRef.close();
          }, 3000);
        },
        (error) => {
          this.dialogRef.close(error);
        },
      );
  }

  getErrorMessage(input: string): string {
    const keys = Object.keys(this.formGroup.controls[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  checkPasswordRepeatValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.parent &&
      control.value !== (control.parent.controls['newPasswordControl'] as AbstractControl).value
        ? { notRepeated: true }
        : null;
  }

  checkForMatch() {
    if ((this.formGroup.get('newPasswordControl').value as string).length > 0) {
      this.formGroup.get('repeatPasswordControl').updateValueAndValidity();
    }
  }
}
